/**
 * Имя клиента, когда его не ввели: из заказа и из звонка клиента заводят по одному
 * телефону, а имя бэку нужно непустым. Показываем маску с последними четырьмя
 * цифрами — по ним клиента отличают в списке, пока он не заполнил профиль сам.
 *
 * На вход — номер в том же виде, в каком уходит на бэк: десять цифр без кода страны.
 */
export const buildFallbackCustomerName = (phone: string): string =>
    `+7 (XXX) XXX-${phone.slice(6, 8)}-${phone.slice(8, 10)}`;
